import { OfficeId, SimpleMission } from "../store/types/MissionsTypes"

interface DataReceiptBase {
    // MM-DD-YYYY format
    date_received: string
    office: OfficeId

    // Received By Employee ID
    received_by: string
}

export interface DataReceiptSimple {
    id: number
    /**
     * MM-DD-YYYY format
     */
    date_received: string
    received_by: string
    received_by_name: string
    office: OfficeId
}

export interface ShipmentDetails {
    id: number
    status: DataReceivedStatus
    size_in_gb: number | null
    notes: string
    receipt: DataReceiptSimple
    mission_shipping_info: {
        id: number
        office_id: OfficeId
        delivery_drive_name: string | null
        shipping_number: string | null
        mission: SimpleMission
    } | null
}

export interface DataReceiptForm extends Omit<DataReceiptBase, "received_by" | "office"> {
    id?: number
    office?: OfficeId
    received_by?: string
}

export interface DataReceiptDto extends DataReceiptBase {
    id?: number
    details: ReceiptDetailDto[]

    // On Post
    deleted_details?: number[]
}

/**
 * Post
 */
export interface ReceiptDetailDto {
    id?: number
    // the corresponding shipping info id the record was created off of
    mission_shipping_info_id: number

    status: DataReceivedStatus
    size_in_gb?: number
    notes: string
}

export enum DataReceivedStatus {
    ERROR = "ERROR",
    RECEIVED = "RECEIVED",
}

export const dataReceivedStatusUserDisplayValue = (status: DataReceivedStatus) => {
    switch (status) {
        case DataReceivedStatus.RECEIVED:
            return "Received"
        case DataReceivedStatus.ERROR:
            return "Error"
        default:
            throw new Error(`No user display value available for Data Received Status: ${status}`)
    }
}

/**
 * From Mission table
 */
export interface MissionInReceiptShippingInfo {
    mission_id: number
    mission_name: string
    project_name: string
    project_number: string
    num_flightlines: number
    error_notes: string
    error_action: string
    sensor_notes: string
    operator_1_name?: string
    platform?: {
        platform_name: string
    }

    // MM-DD-YYYY
    flown_date: string
}

/**
 * From Mission Shipping Info Table
 * this is what is shown in the Data Receipt Select Mission Shipping table
 */
export interface ReceiptShippingInfoBase {
    id: number
    delivery_drive_name: string
    shipping_number: string
    office: OfficeId
    plane_drive_name: string
    raw_storage_size_gb: number
}

export interface ReceiptShippingInfoDto extends ReceiptShippingInfoBase {
    // Mission fields
    mission: MissionInReceiptShippingInfo
}

export interface ReceiptDetail {
    notes: string
    status: DataReceivedStatus
    size_in_gb?: number
    id?: number
}

/**
 * Frontend wrapper
 * Adds the notes and status fields to selected shipping info obj
 */
export interface ReceiptShippingInfoWrapper {
    shipping_info: ReceiptShippingInfoBase
    detail: ReceiptDetail
    mission: MissionInReceiptShippingInfo
    fe_id: number
}

/**
 * To view a data receipt we need the nested mission and shipping_info data
 */

interface SingleDataReceiptDetailDto extends ReceiptDetail {
    mission: MissionInReceiptShippingInfo
    shipping_info: ReceiptShippingInfoBase
}

export interface SingleDataReceiptDto extends DataReceiptBase {
    id: number
    details: SingleDataReceiptDetailDto[]
}
